import React from 'react';
import { addElement } from '../../../actions/CreateSiteActions/createSiteActions'
import { connect } from 'react-redux';
import { ADD_TITLE, SET_TITLE_VALID, ADD_NAME, ADD_IDGINTEGRATION } from "../../../actions/types";
import { validateTitle } from "./Validation/TitleValidation";
import { updateValidationStatus } from "../../../actions/ValidationActions/validateStep2Acitons";
import RequiredTextField from '../../formFields/RequiredTextField'
import InfoTooltip from '../../formFields/InfoTooltip';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { validate } from "../../../actions/ValidationActions/serverValidation";


class Title extends React.Component {

    state = {
        isValidating: false,
        idgValidationNeeded: false
    }

    // componentDidMount() {
    //     this.props.addTitle(ADD_NAME, this.props.localName);
    // }

    componentDidUpdate(prevProps) {
        if (this.isIdgIntegration() && this.props.idgIntegration.idgValidationNeeded) {
            if (this.props.idgIntegration.useExistingNumber) {
                this.validate(this.props.localTitle)
            } else if (validateTitle(this.props.localTitle).isValid) {
                this.validateTitleInIDG(this.props.localTitle);
            }
            
            this.props.addElement(ADD_IDGINTEGRATION, {...this.props.idgIntegration, idgValidationNeeded: false})
        }
    }

    validate(value) {
        const error = validateTitle(value);
        this.props.updateValidationStatus(SET_TITLE_VALID, error)
    }

    onWriteEvent = (e, value) => {
        value = value.replace(/^\s*/, '');

        if (this.isIdgIntegration() && !this.props.idgIntegration.useExistingNumber) {
            this.setState({idgValidationNeeded: true});
        }

        this.props.addTitle(ADD_TITLE, value);
        this.validate(value);
    }

    generateNameFromTitle(title) {
        //var output = title.replace(/\s+(\w)?/gi, (match, letter) => {
        var output = title.trim().replace(/\s+(\S)/gi, (match, letter) => {
            //return letter ? letter.toUpperCase() : '';
            return letter;
        });

        return output.replace(/[^\w-]|^[-_]|[-_]$/g, '');
    }

    onBlurEvent = () => {
        if (this.props.localTitle) {
            if (this.props.localTitle !== this.props.localTitle.trim()) {
                this.props.addTitle(ADD_TITLE, this.props.localTitle.trim());
            }

            if (!this.props.localName) {
                const name = this.generateNameFromTitle(this.props.localTitle);
                this.props.addTitle(ADD_NAME, name);
            }
            
            if (this.isIdgIntegration() && this.state.idgValidationNeeded && validateTitle(this.props.localTitle).isValid) {
                this.validateTitleInIDG(this.props.localTitle);
            }
        }
    }

    isIdgIntegration = () => {
        return this.props.idgIntegration;
    }

    validateTitleInIDG = (title) => {        
        this.props.updateValidationStatus(SET_TITLE_VALID, {isValid: false});

        if (!this.props.idgIntegration.instanceCode)
            return;

        this.setState({ isValidating: true });

        var validationUrl = `/entryvalidation?title=${encodeURIComponent(title.trim())}&idgInstanceCode=${this.props.idgIntegration.instanceCode}`

        this.props.validate(validationUrl, SET_TITLE_VALID)
            .then(() => { 
                this.setState({ isValidating: false, idgValidationNeeded: false }) 
            });
    }

    render() {       
        const validatingSpinner = <div title='Validating...' className='validation-spinner-withLabel'><Spinner size={SpinnerSize.medium} /></div>

        const toolTipContent =
            <span>The name will automatically generate the site’s address. The display name can be changed later, the URL however not. <br />
                <br />
                Please refer to the <a href='https://abb.sharepoint.com/:b:/s/learn365/en-us/Ede8ilXleVVDn7kVAvzwDXABvjU1Ziav0h4xQYn0hUouXQ?e=vlzaLz' target="_blank" rel='noopener noreferrer'>
                naming convention guidelines
                </a> to learn more. <br />            
            </span>;

        const toolTipContentIATU =
            <span>The project name must follow this convention:<br />
                <ul><li><b>"AA - Project name"</b>, where "AA" is the project type</li></ul>
            Project types:<br />
            CPI - Continuous Product Improvement<br />
            BD - Business Project<br />
            IP - Investment Project<br />
            NP - New Product<br />
            PD - Product Development / Next Generation<br />
            PE - Product Enhancement<br />
            PIP - Process Improvement project<br />
            PM - Product Maintenence<br />
            SP - System Project<br />
            TD - Technology Development
        </span>;

        return (
            <div className='wizard-inside'>
                <div className='item-title'>
                    {this.props.isIATU || this.props.isIAPCP ? "Project name" : "Site display name"}
                    <InfoTooltip content={this.props.isIATU || this.props.isIAPCP ? toolTipContentIATU : toolTipContent} />
                </div>
                {this.state.isValidating && validatingSpinner}
                <RequiredTextField
                    name='Title'
                    onChange={this.onWriteEvent}
                    value={this.props.localTitle}
                    validationResult={this.props.validationResult}
                    onBlur={this.onBlurEvent}
                />
            </div>
        );
    }
}

const mapActionToProp = {
    addTitle: addElement,
    updateValidationStatus,
    validate,
    addElement
}

const mapStateToProps = state => ({
    localTitle: state.newSite.Title,
    localName: state.newSite.Name,
    validationResult: state.step2Validation.TitleValid,
    possibleWarning: state.wizard.nextStepRequested,
    isIATU: state.newSite.isIATU,
    isIAPCP: state.newSite.isIAPCP,
    template: state.newSite.Template,
    idgIntegration: state.newSite.idgIntegration
})

export default connect(mapStateToProps, mapActionToProp)(Title);







// WEBPACK FOOTER //
// ./src/components/CreateSite/Step2/Title.js